export default __webpack_public_path__ + "static/media/Group9255.e2d2dbe1.svg";